/**
 * @fileoverview Korean translations.
 * @summary Korean translation strings for KaraoNow frontend.
 *
 * @package KaraoNow
 * @module apps/front/src/utils/i18n/locales/ko
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
export const ko = {
  // Common
  common: {
    loading: '로딩 중...',
    processing: '처리 중',
    error: '오류',
    success: '성공',
    cancel: '취소',
    confirm: '확인',
    save: '저장',
    delete: '삭제',
    edit: '편집',
    create: '생성',
    back: '뒤로',
    next: '다음',
    previous: '이전',
    search: '검색',
    filter: '필터',
    close: '닫기',
    backHome: '홈으로 돌아가기',
    creating: '생성 중...',
    refresh: '새로고침',
  },
  // Error codes
  // errors: {
  //   generic: 'An error occurred',
  //   VALIDATION_ERROR: 'Validation error',
  //   CREATE_EVENT_ERROR: 'Error creating event',
  //   UPDATE_EVENT_ERROR: 'Error updating event',
  //   EVENT_NOT_FOUND: 'Event not found',
  //   VENUE_NOT_FOUND: 'Venue not found',
  //   // Validation errors by field and Zod code
  //   validation: {
  //     name: {
  //       too_small: 'Event name is required',
  //       required: 'Event name is required',
  //       invalid_type: 'Event name is invalid',
  //     },
  //     date: {
  //       required: 'Date is required',
  //       invalid_type: 'Date is invalid',
  //       invalid_date: 'Date is invalid',
  //       invalid_string: 'Date format is invalid',
  //     },
  //     description: {
  //       invalid_type: 'Description is invalid',
  //     },
  //     venueId: {
  //       invalid_type: 'Venue is invalid',
  //     },
  //   },
  // },
  // Auth
  auth: {
    login: '로그인',
    register: '회원가입',
    logout: '로그아웃',
    email: '이메일',
    password: '비밀번호',
    confirmPassword: '비밀번호 확인',
    forgotPassword: '비밀번호를 잊으셨나요?',
    rememberMe: '로그인 상태 유지',
    loginButton: '로그인',
    registerButton: '가입하기',
    alreadyHaveAccount: '이미 계정이 있으신가요?',
    dontHaveAccount: '계정이 없으신가요?',
    role: '역할',
    organizer: '주최자',
    singer: '가수',
    firstName: '이름',
    lastName: '성',
    pseudo: '닉네임',
    organization: '조직',
    sendVerificationEmail: '인증 이메일 보내기',
    emailVerificationSent: '인증 이메일이 전송되었습니다',
    emailVerificationInstructions: '{{email}}로 인증 이메일이 전송되었습니다. 이메일의 링크를 클릭하여 등록을 완료하세요.',
    backToLogin: '로그인으로 돌아가기',
    optional: '선택사항',
    registerOrganizerTitle:'주최자 등록',
    registerSingerTitle: '가수 등록',
    registerOrganizerDescription: '노래방 이벤트를 주최하기 위한 계정을 만드세요',
    registerSingerDescription: '노래방 이벤트에 참여하기 위한 계정을 만드세요',
    setPassword: '비밀번호 만들기',
    setPasswordTitle: '등록 완료',
    setPasswordDescription: '등록을 완료하기 위해 비밀번호를 만드세요',
    createPassword: '비밀번호 만들기',
    passwordRequirements: '최소 12자, 대문자, 소문자, 숫자 및 특수 문자 포함',
    forgotPasswordDescription: '이메일 주소를 입력하시면 비밀번호 재설정 링크를 보내드립니다.',
    sendResetLink: '재설정 링크 보내기',
    resetPasswordEmailSent: '비밀번호 재설정 이메일이 전송되었습니다',
    resetPasswordInstructions: '{{email}}로 비밀번호 재설정 이메일이 전송되었습니다. 이메일의 링크를 클릭하여 비밀번호를 재설정하세요.',
    resetPassword: '비밀번호 재설정',
    resetPasswordDescription: '계정의 새 비밀번호를 만드세요',
    resetPasswordButton: '비밀번호 재설정',
    passwordResetSuccess: '비밀번호 재설정',
    passwordResetSuccessDescription: '비밀번호가 성공적으로 재설정되었습니다. 로그인 페이지로 리디렉션됩니다.',
    resetLinkExpired: '재설정 링크 만료',
    resetLinkExpiredDescription: '이 재설정 링크가 만료되었습니다(1시간 동안 유효). 새 링크를 요청하세요.',
    requestNewResetLink: '새 링크 요청',
    rememberPassword: '비밀번호를 기억하시나요?',
  },
  // Organizer menu
  organizerMenu: {
    menu: '주최자 메뉴',
    dashboard: '대시보드',
    venues: '장소',
    settings: '설정',
    dataPrivacy: '개인 데이터',
    subscriptions: '가격',
    about: '정보',
    user: '사용자',
  },
  // Errors
  errors: {
    genericMessage: '오류가 발생했습니다',
    required: '이 필드는 필수입니다',
    invalidEmail: '유효하지 않은 이메일',
    passwordTooShort: '비밀번호는 최소 12자 이상이어야 합니다',
    passwordRequirements: '비밀번호는 최소 하나의 대문자, 소문자, 숫자 및 특수 문자를 포함해야 합니다',
    passwordsDoNotMatch: '비밀번호가 일치하지 않습니다',
    loginFailed: '로그인 실패',
    registerFailed: '등록 실패',
    resetPasswordFailed: '비밀번호 재설정 실패',
    invalidToken: '유효하지 않거나 만료된 토큰',
    networkError: '네트워크 오류',
    unauthorized: '인증되지 않음',
    forbidden: '액세스 거부',
    notFound: {
      title: '페이지를 찾을 수 없음',
      description: '찾고 있는 페이지가 존재하지 않거나 이동되었습니다.',
      explore: '앱 탐색하기',
    },
    server: {
      title: '서버 오류',
      description: '예기치 않은 오류가 발생했습니다. 나중에 다시 시도해 주세요.',
    },
    generic: {
      title: '이런, 문제가 발생했습니다',
      description: '예기치 않은 오류가 발생했습니다. 다시 시도해 주세요.',
    },
    serverError: '서버 오류',
    // Error codes from backend
    VALIDATION_ERROR: '유효성 검사 오류',
    CREATE_EVENT_ERROR: '이벤트 생성 오류',
    UPDATE_EVENT_ERROR: '이벤트 업데이트 오류',
    EVENT_NOT_FOUND: '이벤트를 찾을 수 없음',
    VENUE_NOT_FOUND: '장소를 찾을 수 없음',
    QUOTA_EXCEEDED_CREATE: '이벤트 생성 월간 할당량 도달',
    QUOTA_EXCEEDED_DATE_CHANGE: '{{planName}} 플랜의 이번 달 할당량이 도달했습니다: 월 최대 {{limit}}개 이벤트. 할당량은 청구 기간 종료 시 재설정됩니다.',
    SUBSCRIPTION_EVENT_CANNOT_CONVERT: '구독 플랜에 포함된 이벤트는 단일 이벤트로 변환할 수 없습니다',
    EVENT_DATE_NOT_REACHED: '예정된 날짜 전에 이벤트를 활성화할 수 없습니다',
    EVENT_DATE_PAST: '이벤트 날짜는 과거일 수 없습니다',
    EVENT_DATE_AFTER_EXPIRATION: '이벤트 날짜는 고유 이벤트의 만료일 이후일 수 없습니다',
    // Validation errors by field and Zod code
    validation: {
      name: {
        too_small: '이벤트 이름은 필수입니다',
        required: '이벤트 이름은 필수입니다',
        invalid_type: '이벤트 이름이 유효하지 않습니다',
      },
      date: {
        required: '날짜는 필수입니다',
        invalid_type: '날짜가 유효하지 않습니다',
        invalid_date: '날짜가 유효하지 않습니다',
        invalid_string: '날짜 형식이 유효하지 않습니다',
      },
      description: {
        invalid_type: '설명이 유효하지 않습니다',
      },
      venueId: {
        invalid_type: '장소가 유효하지 않습니다',
      },
    },
  },
  // Landing page
  landing: {
    languageLabel: '언어를 선택하세요',
    heroTitle: '노래방 밤을 더 쉽게.',
    heroSubtitle: '2분 만에 이벤트 생성. 게스트가 QR 코드로 노래를 추가하고, 흐름은 당신이 쥐고 있어요.',
    ctaPrimary: '첫 노래방 만들기 — 무료',
    ctaOrganize: '주최하고 싶어요',
    ctaOrganizeDesc: '이벤트를 만들고, 플레이리스트를 관리하고, 순서를 파악하세요.',
    ctaSing: '노래하고 싶어요',
    ctaSingDesc: 'QR 코드로 이벤트에 참여하고 노래를 추가하세요.',
    alreadyAccount: '이미 계정이 있으신가요?',
    login: '로그인',
    whyTitle: '왜 KaraoNow인가요?',
    benefit1Title: 'QR 하나로, 종이는 제로',
    benefit1Desc: '게스트가 스마트폰으로 스캔해 노래를 골라요. 종이 리스트 분실은 이제 없어요.',
    benefit2Title: '실시간 플레이리스트',
    benefit2Desc: '순서가 모두에게 보여요. 흐름 따라가기만 하면 됩니다.',
    benefit3Title: '무료로 시작',
    benefit3Desc: '무료 이벤트 최대 4회. 원할 때 무제한 플랜으로 전환하세요.',
    twoWaysTitle: 'KaraoNow를 쓰는 두 가지 방법',
    learnMore: '자세히 보기',
  },
  // Home page
  home: {
    title: '노래방 이벤트 플레이리스트 관리',
    wantToSing: '노래하고 싶어요',
    wantToSingDescription: '이벤트에 참여하고 노래를 추가하세요',
    wantToOrganize: '주최하고 싶어요',
    wantToOrganizeDescription: '노래방 이벤트를 만들고 관리하세요',
    alreadyHaveAccount: '이미 계정이 있으신가요?',
  },
  // Dashboard
  dashboard: {
    title: '주최자 대시보드',
    welcome: '환영합니다',
    events: '이벤트',
    createEvent: '이벤트 만들기',
    noEvents: '이벤트 없음',
    noEventsDescription: '첫 번째 노래방 이벤트를 만들어 시작하세요',
    filterAll: '전체',
    filterDraft: '초안',
    filterActive: '활성',
    filterCompleted: '완료됨',
    filterCancelled: '취소됨',
    loadingEvents: '이벤트 로딩 중...',
    errorLoadingEvents: '이벤트 로딩 오류',
    noEventsMatchingFilter: '이 필터와 일치하는 이벤트가 없습니다',
    tryDifferentFilter: '다른 필터를 선택해 보세요',
  },
  // Events
  events: {
    name: '이벤트',
    events: '이벤트',
    song: '노래',
    songs: '노래',
    description: '설명',
    date: '날짜',
    time: '시간',
    venue: '장소',
    selectVenue: '장소 선택',
    namePlaceholder: '나의 노래방 밤',
    descriptionPlaceholder: '선택적 설명...',
    createTitle: '이벤트 만들기',
    createSubtitle: '새로운 노래방 이벤트 만들기',
    createButton: '이벤트 만들기',
    createEvent: '이벤트 만들기',
    createSuccess: '이벤트가 성공적으로 생성되었습니다',
    createError: '이벤트 생성 오류',
    noVenues: '사용 가능한 장소가 없습니다. 먼저 장소를 만드세요.',
    createVenue: '장소 만들기',
    status: '상태',
    statusDraft: '초안',
    statusActive: '활성',
    statusCompleted: '완료됨',
    statusCancelled: '취소됨',
    statusHidden: '숨김',
    createdAt: '생성일',
    updatedAt: '수정일',
    view: '보기',
    open: '열기',
    edit: '편집',
    delete: '삭제',
    qrCode: 'QR 코드',
    deleteConfirmTitle: '이벤트 삭제',
    deleteConfirm: '이벤트 "{{name}}"을(를) 삭제하시겠습니까?',
    deleteSuccess: '이벤트가 성공적으로 삭제되었습니다',
    deleteError: '이벤트 삭제 오류',
    managementTitle: '이벤트 관리',
    editEvent: '이벤트 편집',
    updateSuccess: '이벤트가 성공적으로 업데이트되었습니다',
    updateError: '이벤트 업데이트 오류',
    showQRCode: 'QR 코드 표시',
    hideQRCode: 'QR 코드 숨기기',
    qrCodeTitle: '이벤트 QR 코드',
    qrCodeDescription: '참가자들과 이 코드를 공유하여 이벤트에 참여할 수 있도록 하세요',
    copyQRCode: '링크 복사',
    qrCodeCopied: '링크가 클립보드에 복사되었습니다',
    shareQRCode: '공유',
    queue: '대기열',
    singers: '가수',
    noQueue: '대기열에 노래가 없습니다',
    noSingers: '등록된 가수가 없습니다',
    guest: '게스트',
    singer: '가수',
    songsCount_one: '{{count}}곡',
    songsCount_other: '{{count}}곡',
    deleteQueueItem: '노래 삭제',
    deleteQueueItemConfirm: '이 노래를 대기열에서 제거하시겠습니까?',
    deleteSinger: '가수 제거',
    deleteSingerConfirm: '이 가수를 제거하시겠습니까? 대기열의 모든 노래도 제거됩니다.',
    singerDeleteError: '가수 제거 오류',
    moveUp: '위로 이동',
    moveDown: '아래로 이동',
    dragToReorder: '드래그하여 재정렬',
    setCurrent: '현재로 설정',
    markCompleted: '완료로 표시',
    cancel: '취소',
    queueUpdateError: '대기열 업데이트 오류',
    queueDeleteError: '노래 삭제 오류',
    queueStatusPending: '대기 중',
    queueStatusCurrent: '현재',
    queueStatusCompleted: '완료됨',
    queueStatusCancelled: '취소됨',
    qrCodeUrl: '이벤트 URL',
    qrCodeShareText: '이 노래방 이벤트에 함께 참여하세요: {{eventName}}!',
    qrCodePrintTitle: 'QR 코드 - KaraoNow',
    qrCodePrintInstructions: '이 QR 코드를 스캔하여 이벤트에 접근하고 대기열에 노래를 추가하세요.',
    qrCodePrint: '인쇄',
    qrCodeShare: '공유',
    qrCodeDownload: '다운로드',
    startEvent: '이벤트 시작',
    start: '시작',
    completeEvent: '이벤트 완료',
    complete: '완료',
    cancelEvent: '이벤트 취소',
    cancelConfirmTitle: '취소 확인',
    cancelConfirmMessage: '이 이벤트를 취소하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    cancelConfirmOneShotTitle: '취소 확인 - 일회성 이벤트',
    cancelConfirmOneShotMessage: '⚠️ 경고: 이 일회성 이벤트는 구매되었습니다. 취소는 최종이며 이벤트가 사용되지 않은 경우 환불되지 않습니다. 이 이벤트를 취소하시겠습니까?',
    cancelConfirmButton: '예, 취소합니다',
    cancelCancelButton: '아니요, 이벤트 유지',
    deleteEvent: '이벤트 삭제',
    deleteEventConfirm: '이 이벤트를 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    hide: '숨기기',
    hideConfirmTitle: '이벤트 숨기기',
    hideConfirm: '이벤트 "{{name}}"을(를) 숨기시겠습니까? 메인 목록에 더 이상 표시되지 않지만 월간 할당량에는 여전히 포함됩니다.',
    hideSuccess: '이벤트가 성공적으로 숨겨졌습니다',
    hideError: '이벤트 숨기기 오류',
    hidden: '숨김',
    showHidden: '숨김',
    hiddenEventTitle: '숨겨진 이벤트',
    hiddenEventMessage: '이 이벤트는 숨겨져 있으며 더 이상 접근할 수 없습니다. 월간 할당량에는 여전히 포함됩니다.',
    hiddenEventTooltip: '이 이벤트는 숨겨져 있으며 볼 수 없습니다',
    statusUpdated: '이벤트 상태가 업데이트되었습니다',
    backToEvent: '이벤트로 돌아가기',
    // Quota exceeded for date change
    quotaExceededDateChange: '이 날짜의 월간 할당량 도달',
    quotaExceededDateChangeTitle: '월간 할당량 도달',
    quotaExceededDateChangeExplanation: '이벤트 "{{eventName}}"의 날짜를 변경할 수 없습니다. 월간 이벤트 할당량을 초과하게 됩니다.',
    quotaExceededDateChangeOptions: '원래 날짜를 유지하거나 이 이벤트를 "단일 이벤트"로 변환하여 월간 할당량에서 제외할 수 있습니다.',
    quotaExceededDetails: '이 기간 동안 {{limit}}개 중 {{current}}개의 이벤트가 있습니다.',
    upgradeToOneShotOption: '옵션: 단일 이벤트로 업그레이드',
    upgradeToOneShotDescription: '이 이벤트를 "단일 이벤트"로 변환하면 월간 할당량에 포함되지 않으며 날짜를 자유롭게 변경할 수 있습니다.',
    upgradeToOneShotNow: '🚀 단일 이벤트로 업그레이드',
    keepOriginalDate: '원래 날짜 유지',
    multipleEventsPremiumSuggestion: '여러 이벤트? 프리미엄 플랜이 더 비용 효율적일 수 있습니다.',
    // Quota exceeded for event creation
    quotaExceededCreateTitle: '월간 할당량 도달',
    quotaExceededCreateMessage: '{{planName}}의 한계에 도달했습니다. 이 기간 동안 더 많은 이벤트를 만들 수 없습니다.',
    quotaExceededCreateExplanation: '월간 이벤트 할당량에 도달했습니다. 청구 기간 종료를 기다리거나 더 높은 플랜으로 업그레이드할 수 있습니다.',
    quotaExceededCreateOptions: '월간 할당량에 포함되지 않는 단일 이벤트를 만들 수도 있습니다.',
    // Quota exceeded for FREE plan (no monthly/billing period references)
    quotaExceededCreateTitleFree: '할당량 도달',
    quotaExceededCreateMessageFree: '{{planName}}의 한계에 도달했습니다. 더 많은 이벤트를 만들 수 없습니다.',
    quotaExceededCreateExplanationFree: '무료 플랜의 이벤트 한계에 도달했습니다. 더 많은 이벤트를 만들려면 더 높은 플랜으로 업그레이드할 수 있습니다.',
    quotaExceededCreateOptionsFree: '할당량에 포함되지 않는 단일 이벤트를 만들 수도 있습니다.',
    quotaExceededDetailsFree: '{{limit}}개 중 {{current}}개의 이벤트가 있습니다.',
    createOneShotDescriptionFree: '할당량에 포함되지 않는 단일 이벤트를 만드세요.',
    upgradePlanDescriptionFree: '이벤트 할당량을 늘리려면 더 높은 플랜으로 업그레이드하세요.',
    createOneShotOption: '옵션: 단일 이벤트 만들기',
    createOneShotDescription: '월간 할당량에 포함되지 않는 단일 이벤트를 만드세요.',
    createOneShotNow: '🚀 단일 이벤트 만들기',
    upgradePlanOption: '옵션: 더 높은 플랜으로 업그레이드',
    upgradePlanDescription: '월간 이벤트 할당량을 늘리려면 더 높은 플랜으로 업그레이드하세요.',
    upgradePlanNow: '더 높은 플랜으로 업그레이드',
    quotaResetInfo: '할당량은 청구 기간 종료 시 재설정됩니다.',
    // Generic quota exceeded message
    quotaExceeded: '이 날짜의 월간 할당량 도달',
    // Plan subscription badge
    planSubscription: '플랜에 포함됨',
    planSubscriptionTooltip: '구독에 포함된 이벤트',
  },
  // Venues
  venues: {
    title: '장소 관리',
    subtitle: '노래방 장소를 만들고 관리하세요',
    venuesList: '장소 목록',
    addVenue: '장소 추가',
    editVenue: '장소 편집',
    noVenues: '등록된 장소가 없습니다',
    noVenuesDescription: '첫 번째 장소를 만들어 시작하세요',
    eventName: '이벤트 이름',
    eventNamePlaceholder: '{{firstName}}의 노래방',
    name: '장소 이름',
    namePlaceholder: '예: 레 샤 누아르 바',
    address: '주소',
    addressPlaceholder: '예: 음악 거리 123',
    city: '도시',
    cityPlaceholder: '예: 서울',
    country: '국가',
    countryPlaceholder: '예: 대한민국',
    googleMapsUrl: 'Google 지도 링크',
    googleMapsUrlPlaceholder: 'https://maps.google.com/...',
    viewOnGoogleMaps: 'Google 지도에서 보기',
    addSuccess: '장소가 성공적으로 생성되었습니다',
    addError: '장소 생성 오류',
    updateSuccess: '장소가 성공적으로 업데이트되었습니다',
    updateError: '장소 업데이트 오류',
    deleteSuccess: '장소가 성공적으로 삭제되었습니다',
    deleteError: '장소 삭제 오류',
    confirmDelete: '장소 "{{name}}"을(를) 삭제하시겠습니까?',
    confirmDeleteTitle: '장소 삭제',
    cancel: '취소',
    add: '추가',
    edit: '편집',
    save: '저장',
    deleting: '삭제 중...',
    saving: '저장 중...',
    generateMapsUrl: 'Google 지도 링크 생성',
    generateMapsUrlError: '링크를 생성하려면 최소한 장소 이름 또는 도시를 입력하세요',
    mapsModal: {
      title: 'Google 지도에서 위치 선택',
      description: 'Google 지도를 사용하여 장소의 위치를 찾고 정확하게 조정하세요.',
      instructions: '아래의 "Google 지도에서 열기"를 클릭하고, 필요하면 지도의 지점을 조정한 다음, 브라우저 주소 표시줄에서 링크를 복사하여 아래 필드에 붙여넣으세요.',
      urlLabel: 'Google 지도 링크',
      openInMaps: 'Google 지도에서 열기',
      confirm: '확인',
      clickToOpen: 'Google 지도를 열려면 클릭하세요',
      clickDescription: '위치를 조정할 수 있도록 Google 지도가 있는 새 창이 열립니다',
    },
  },
  // Singer interface
  singer: {
    // Dashboard
    dashboard: '대시보드',
    dashboardSubtitle: '이벤트와 노래 보기',
    myEvents: '내 이벤트',
    mySongs: '내 노래',
    allEvents: '전체',
    activeEvents: '활성',
    pastEvents: '과거',
    inactiveEvents: '비활성',
    sortByDate: '날짜별 정렬',
    sortByOrganizer: '주최자별 정렬',
    sortBySongs: '노래 수별 정렬',
    noEvents: '아직 이벤트에 참여하지 않았습니다.',
    noSongs: '아직 노래를 추가하지 않았습니다.',
    eventName: '이벤트 이름',
    organizer: '주최자',
    date: '날짜',
    songsAdded: '추가된 노래',
    songsSung: '부른 노래',
    status: '상태',
    status_active: '활성',
    status_completed: '완료됨',
    status_cancelled: '취소됨',
    status_draft: '초안',
    title: '제목',
    artist: '아티스트',
    event: '이벤트',
    addedDate: '추가 날짜',
    totalEvents: '총 이벤트',
    totalSongs: '총 노래',
    uniqueOrganizers: '고유 주최자',
    // Settings
    settings: '설정',
    settingsSubtitle: '프로필 및 데이터 관리',
    menu: '가수 메뉴',
    profile: '프로필',
    changePassword: '비밀번호 변경',
    changePasswordDescription: '이메일로 비밀번호 재설정 링크를 보내드립니다.',
    sendResetLink: '재설정 링크 보내기',
    passwordResetLinkSent: '비밀번호 재설정 링크가 이메일 주소로 전송되었습니다.',
    accountData: '계정 데이터',
    editProfile: '프로필 편집',
    saveChanges: '변경 사항 저장',
    profileUpdated: '프로필이 성공적으로 업데이트되었습니다',
    changePasswordTitle: '비밀번호 변경',
    currentPassword: '현재 비밀번호',
    newPassword: '새 비밀번호',
    confirmNewPassword: '새 비밀번호 확인',
    passwordRequirements: '비밀번호는 최소 12자, 대문자, 소문자, 숫자 및 특수 문자를 포함해야 합니다.',
    passwordChanged: '비밀번호가 성공적으로 변경되었습니다',
    passwordTooShort: '비밀번호는 최소 12자 이상이어야 합니다',
    passwordsNotMatch: '비밀번호가 일치하지 않습니다',
    currentPasswordRequired: '현재 비밀번호는 필수입니다',
    // Password validation errors
    passwordMinLength: '비밀번호는 최소 12자 이상이어야 합니다',
    passwordNoUppercase: '비밀번호는 최소 하나의 대문자를 포함해야 합니다',
    passwordNoLowercase: '비밀번호는 최소 하나의 소문자를 포함해야 합니다',
    passwordNoDigit: '비밀번호는 최소 하나의 숫자를 포함해야 합니다',
    passwordNoSpecialChar: '비밀번호는 최소 하나의 특수 문자를 포함해야 합니다',
    exportData: '데이터 내보내기',
    exportDataDescription: '모든 개인 데이터의 사본을 JSON 형식으로 다운로드하세요.',
    downloadData: '데이터 다운로드',
    dataExported: '데이터가 성공적으로 내보내졌습니다',
    dangerZone: '위험 구역',
    deleteAccountDescription: '계정 삭제는 되돌릴 수 없습니다. 모든 데이터가 영구적으로 삭제됩니다.',
    deleteAccount: '계정 삭제',
    deleteAccountConfirm: '삭제',
    confirmDeleteAccount: '계정을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    // QR Code Landing
    qrCodeMissing: 'QR 코드 토큰이 없습니다',
    qrCodeError: 'QR 코드 검증 오류',
    eventNotFound: '이벤트를 찾을 수 없거나 토큰이 유효하지 않습니다',
    organizerNotAllowed: '당신은 주최자입니다. 대시보드를 사용하여 이 이벤트를 관리하세요.',
    accessDenied: '액세스 거부',
    validatingQRCode: 'QR 코드 검증 중...',
    chooseAccessMethod: '이벤트 참여 방법 선택',
    continueAsGuest: '게스트로 계속',
    orWithAccount: '또는 계정으로',
    enterPseudo: '이벤트에 참여할 닉네임을 입력하세요',
    joinEvent: '이벤트 참여',
    joining: '참여 중...',
    sessionError: '세션 생성 오류',
    joinError: '이벤트 참여 오류',
    sessionExpired: '세션이 만료되었습니다. 이벤트 QR 코드를 다시 스캔하세요.',
    guestMode: '게스트 모드',
    leaveEvent: '이벤트 나가기',
    // Singer Event Page
    eventNotActive: '이 이벤트는 아직 활성화되지 않았습니다. 나중에 다시 오세요!',
    eventNotStarted: '이 이벤트는 아직 시작되지 않았습니다. 주최자가 노래방을 시작하면 사용할 수 있습니다!',
    eventNotYetAvailable: '이 이벤트는 아직 사용할 수 없습니다. 예정된 날짜까지 기다려주세요.',
    eventEnded: '이 이벤트가 종료되었습니다. 더 이상 투표를 받지 않습니다.',
    eventCancelled: '이 이벤트가 취소되었습니다. 투표를 사용할 수 없습니다.',
    searchSong: '노래 검색',
    searchResults: '검색 결과',
    advancedSearch: '고급 검색',
    advancedSearchToggle: '고급 검색',
    simpleSearch: '간단한 검색',
    searchPlaceholder: '제목 또는 아티스트...',
    titlePlaceholder: '제목...',
    artistPlaceholder: '아티스트...',
    noResults: '결과를 찾을 수 없습니다',
    addCustomSong: '이 곡 추가',
    addCustomSongDescription: '이 곡은 데이터베이스에 저장되고 대기열에 추가됩니다.',
    addAndQueue: '추가하고 대기열에 넣기',
    localResults: '데이터베이스에서 {{count}}개의 결과를 찾았습니다',
    musicbrainzResults: '{{count}}개의 MusicBrainz 결과',
    moreResults: '더 많은 결과',
    addError: '대기열에 추가 오류',
    queueLimitReached: '한계 도달: 이 이벤트의 주최자는 대기열에서 최대 {{limit}}곡으로 제한되는 무료 플랜을 사용하고 있습니다. 대기열에는 현재 {{currentCount}}곡이 포함되어 있습니다. 더 많은 노래를 추가하려면 주최자에게 문의하세요.',
    songAdded: '"{{title}}"이(가) 대기열에 추가되었습니다!',
    myQueue: '내 노래',
    noSongsInQueue: '아직 노래를 추가하지 않았습니다',
    fullQueue: '대기열',
    queueEmpty: '대기열이 비어 있습니다',
    you: '당신',
    unknown: '알 수 없음',
    // Queue statuses
    statusPending: '대기 중',
    statusCurrent: '현재',
    statusCompleted: '완료됨',
    statusCancelled: '취소됨',
  },
  // Singer menu
  singerMenu: {
    about: '정보',
    dataPrivacy: '개인 데이터',
  },
  // Subscription and Plans
  subscription: {
    title: '플랜 및 가격',
    subtitle: '필요에 맞는 플랜을 선택하세요',
    currentPlan: '현재 플랜',
    planFree: '무료 플랜',
    planOneShot: '단일 이벤트',
    planPro: '프로 플랜',
    planPremium: '프리미엄 플랜',
    planUltimate: '얼티밋 플랜',
    planFreeDescription: '시작하기에 완벽합니다',
    planOneShotDescription: '단일 이벤트용',
    planProDescription: '정기 주최자용',
    planPremiumDescription: '열정가용',
    planUltimateDescription: '전문가용',
    priceFreeFree: '무료',
    priceOneShotPer: '{{price}}€ / 이벤트',
    priceProPer: '{{price}}€ / 월',
    pricePremiumPer: '{{price}}€ / 월',
    priceUltimatePer: '{{price}}€ / 월',
    maxEvents: '최대 이벤트',
    maxSongsPerEvent: '이벤트당 노래',
    unlimited: '무제한',
    features: '기능',
    currentPlanBadge: '현재 플랜',
    changePlan: '플랜 변경',
    upgradePlan: '프리미엄으로 업그레이드',
    upgradePlanButton: '더 높은 플랜으로 업그레이드',
    selectPlan: '이 플랜 선택',
    monthlyQuota: '월간 할당량',
    freeQuota: '무료 할당량',
    eventsUsed: '{{current}} / {{limit}} 이벤트',
    billingPeriod: '기간: {{start}} - {{end}}',
    quotaReached: '월간 할당량 도달',
    quotaReachedMessage: '이 기간 동안 이벤트 한계에 도달했습니다. 할당량은 청구 기간 종료 시 재설정됩니다.',
    quotaWarning: '월간 할당량 거의 도달',
    quotaWarningMessage: '이 기간 동안 {{remaining}}개의 이벤트가 남아 있습니다.',
    quotaInfo: '이 기간 동안 {{remaining}}개의 이벤트가 남아 있습니다.',
    learnMore: '자세히 알아보기',
    contactSupport: '지원팀에 문의',
    freePlanNote: '무료 플랜은 {{maxEvents}}개의 이벤트(모든 상태, 단일 이벤트 제외)와 이벤트당 {{maxSongsPerEvent}}곡으로 제한됩니다.',
    oneShotPlanNote: '이벤트 플레이리스트의 무제한 노래 수. 15일 동안 유효합니다.',
    proPlanNote: '월 {{maxEvents}}개 이벤트(롤링 기간). 무제한 노래.',
    premiumPlanNote: '월 {{maxEvents}}개 이벤트(롤링 기간). 무제한 노래.',
    ultimatePlanNote: '무제한 이벤트 및 노래.',
    noEngagement: '약정 없음.',
    convertEvent: '이벤트 변환',
    createEvent: '이벤트 만들기',
    chooseOption: '옵션 선택:',
    convertDescription: '무료 이벤트를 선택하여 단일 이벤트 플랜으로 변환하세요.',
    createDescription: '단일 이벤트 플랜으로 새 이벤트를 만드세요.',
    noFreeEventsToConvert: '변환할 수 있는 무료 이벤트가 없습니다.',
    selectFreeEvent: '변환할 무료 이벤트 선택:',
    convertThisEvent: '이 이벤트 변환',
    createNewOneShot: '단일 이벤트 만들기',
    newOneShotEventName: '새 단일 이벤트',
    createEventError: '이벤트 생성 오류',
    createOneShotEventTitle: '단일 이벤트 만들기',
    proceedToPayment: '결제 진행',
    // Stripe checkout
    checkoutError: '결제 중 오류가 발생했습니다',
    paymentSuccessful: '결제 성공!',
    paymentProcessing: '결제가 처리 중입니다. 곧 리디렉션됩니다.',
    redirectingIn5: '5초 후 자동 리디렉션...',
    backToSubscription: '플랜으로 돌아가기',
    successTitle: '결제 확인됨',
    successSubtitle: '구매해 주셔서 감사합니다',
    paymentCancelled: '결제 취소됨',
    checkoutCancelledMessage: '결제를 취소했습니다. 언제든지 다시 시도할 수 있습니다.',
    cancelledTitle: '결제 취소됨',
    cancelledSubtitle: '플랜으로 돌아가서 다시 시도하세요',
    whatHappensNext: '다음에 무엇이 일어나나요?',
    webhooksProcessing: '결제를 처리하고 있습니다',
    subscriptionActive: '구독이 곧 활성화됩니다',
    confirmationEmail: '확인 이메일을 받게 됩니다',
    // Subscription cancellation
    cancelConfirm: '구독을 취소하시겠습니까?',
    cancelDetails: '현재 청구 기간 종료까지 프리미엄 플랜에 계속 액세스할 수 있습니다. 그 날짜 이후에는 무료 플랜으로 다운그레이드됩니다.',
    cancelSuccess: '구독이 성공적으로 취소되었습니다.',
    cancelPlan: '취소',
    cancellationInProgress: '구독 취소가 이미 진행 중입니다. 청구 기간 종료 시 무료 플랜으로 전환됩니다.',
    cancellationInProgressTitle: '취소 진행 중',
    cancellationInProgressMessage: '구독 취소가 이미 진행 중입니다. 현재 청구 기간 종료 시 무료 플랜으로 전환됩니다. 추가 조치가 필요하지 않습니다.',
    accessUntil: '{{date}}까지 액세스할 수 있습니다.',
    cancelError: '구독 취소 중 오류가 발생했습니다',
    cancelModalTitle: '구독 취소',
    cancelModalMessage: '현재 청구 기간 종료까지 프리미엄 플랜에 계속 액세스할 수 있습니다. 그 날짜 이후에는 자동으로 무료 플랜으로 전환됩니다.',
    cancelModalConfirm: '예, 구독을 취소합니다',
    endOfBillingPeriod: '청구 기간 종료',
    // Single event upgrade
    upgradeToOneShot: '단일 이벤트로 업그레이드',
    upgradeOneShotConfirm: '이벤트 "{{eventName}}"을(를) 단일 이벤트로 업그레이드하려고 합니다.',
    oneShotDescription: '이 특정 이벤트에서 무제한 노래를 위한 일회성 결제입니다.',
    price: '가격',
    oneTimePayment: '일회성 결제',
    whatYouGet: '받게 될 것:',
    unlimitedSongs: '이 이벤트의 무제한 노래',
    noLimits: '대기열 제한 없음',
    oneShotValidity: '이벤트 완료까지 유효',
    upgradeNow: '지금 업그레이드',
    upgradeError: '이벤트 업그레이드 오류',
    updateSuccess: '구독이 {{plan}} 플랜으로 성공적으로 업데이트되었습니다',
    changePlanTitle: '플랜 변경',
    changePlanSubtitle: '구독을 수정하려고 합니다',
    newPlan: '새 플랜',
    perMonth: '월',
    upgradeCost: '추가 비용: +{{amount}}€ / 월',
    downgradeCredit: '예상 크레딧: -{{amount}}€ / 월',
    immediateChange: '즉시 변경',
    immediateChangeDescription: '플랜 변경은 즉시 적용됩니다. 비례 청구는 Stripe에서 자동으로 계산됩니다.',
    confirmChange: '변경 확인',
    oneShot: '단일 이벤트',
    oneShotTooltip: '단일 이벤트 구독',
    expiresLabel: '만료일',
    oneShotExpirationTitle: '단일 이벤트 만료',
    oneShotDaysRemaining: '{{count}}일 남음',
    oneShotDaysRemaining_plural: '{{count}}일 남음',
    oneShotExpiresOn: '{{date}}에 만료',
    oneShotExpirationWarning: '⚠️ 이 날짜 이후 이벤트는 무료 플랜으로 되돌아갑니다. 만료 전에 사용하세요!',
    oneShotValidityInfo: '이 구매는 구매일로부터 {{days}}일 동안 유효합니다. 만료 전에 사용하세요!',
    upgradeToUnlimited: '🚀 무제한으로 가기',
    upgradeToUnlimitedNow: '🚀 지금 무제한으로 가기',
    upgradeSingleEventConfirm: '이벤트 "{{eventName}}"을(를) 무제한으로 업그레이드하려고 합니다.',
    singleEventDescription: '이 특정 이벤트에서 무제한 노래를 위한 일회성 결제입니다.',
    singleEventPlan: '단일 이벤트',
    multiplePremiumSuggestion: '여러 이벤트? 프리미엄 플랜이 더 비용 효율적일 수 있습니다.',
    comparePlans: '플랜 비교 →',
    premium: '프리미엄',
  },
  // Plan alerts
  planAlert: {
    limitReached: '플랜 한계 도달',
    songsLimitReached: '무료 플랜 한계({{limit}}곡)에 도달했습니다. 더 많은 노래를 추가하려면 유료 플랜을 구독하세요.',
    eventsLimitReached: '무료 플랜 한계({{limit}}개 이벤트)에 도달했습니다. 더 많은 이벤트를 만들려면 유료 플랜을 구독하세요.',
    upgrade: '구독',
    dismissible: true,
  },
  pwa: {
    install: '설치',
    installApp: '앱 설치',
    installPrompt: '빠른 액세스를 위해 KaraoNow를 설치하세요!',
    installed: '앱 설치됨',
    offline: '오프라인 상태입니다',
    offlineMessage: '일부 기능이 제한될 수 있습니다.',
    updateAvailable: '업데이트 사용 가능',
    updateNow: '지금 업데이트',
  },
  // About
  about: {
    title: 'KaraoNow 소개',
    subtitle: '노래방 이벤트를 변화시키는 앱을 발견하세요',
    introduction: 'KaraoNow란?',
    introductionText: 'KaraoNow는 노래방 이벤트를 원활하고 전문적으로 관리하도록 설계된 혁신적인 SaaS 플랫폼입니다. 이벤트 주최자이든 열정적인 가수이든, KaraoNow는 잊을 수 없는 노래방 경험을 만들기 위한 도구를 제공합니다.',
    missionText: '우리의 사명은 노래방 플레이리스트 관리를 단순화하고 주최자와 가수 간의 진정한 연결을 만들어 모든 이벤트를 기억에 남고 잘 조직되도록 하는 것입니다.',
    features: '주요 기능',
    feature1Title: '이벤트 관리',
    feature1Desc: '필요한 모든 세부 정보로 노래방 이벤트를 쉽게 만들고 관리하세요.',
    feature2Title: '대화형 참여',
    feature2Desc: '가수들이 QR 코드를 통해 이벤트에 참여하고 좋아하는 노래에 투표할 수 있도록 하세요.',
    feature3Title: '실시간 플레이리스트',
    feature3Desc: '즉시 업데이트로 노래 대기열을 실시간으로 보고 관리하세요.',
    feature4Title: '상세 통계',
    feature4Desc: '차트와 실시간 메트릭으로 이벤트 성과를 분석하세요.',
    feature5Title: '향상된 보안',
    feature5Desc: '데이터는 높은 보안 표준과 강력한 클라우드 인프라로 보호됩니다.',
    feature6Title: '다국어 지원',
    feature6Desc: 'KaraoNow는 전 세계 청중에 도달하기 위해 8개 언어를 지원합니다.',
    technology: '기술 스택',
    frontend: '프론트엔드',
    backend: '백엔드',
    version: '현재 버전',
    versionNote: '새로운 기능으로 정기적으로 업데이트',
    visitWebsite: '공식 웹사이트',
    support: '지원',
    supportNote: '질문이 있으시면 언제든지 문의하세요',
    copyright: '모든 권리 보유.',
    privacyNotice: '데이터 보호에 대해 자세히 알아보려면 법적 페이지를 확인하세요.',
    tryForFree: '무료 체험 시작',
  },
  // Organizer
  organizer: {
    // Dashboard
    dashboard: '대시보드',
    dashboardSubtitle: '노래방 이벤트 관리',
    menu: '주최자 메뉴',
    // Settings
    settings: '설정',
    settingsSubtitle: '프로필 및 설정 관리',
    editProfile: '프로필 편집',
    saveChanges: '변경 사항 저장',
    profileUpdated: '프로필이 성공적으로 업데이트되었습니다',
    emailChangeConfirmTitle: '이메일 주소 수정',
    emailChangeConfirmMessage: '확인 이메일이 새 이메일 주소로 전송됩니다. 새 이메일은 해당 이메일의 링크를 확인한 후에만 유효합니다. 이전 이메일은 확인까지 유효합니다.',
    changePassword: '비밀번호 변경',
    changePasswordDescription: '이메일로 비밀번호 재설정 링크를 보내드립니다.',
    sendResetLink: '재설정 링크 보내기',
    passwordResetLinkSent: '비밀번호 재설정 링크가 이메일로 전송되었습니다.',
    accountData: '계정 데이터',
    exportData: '데이터 내보내기',
    exportDataDescription: '모든 개인 데이터의 사본을 JSON 형식으로 다운로드하세요.',
    downloadData: '데이터 다운로드',
    dataExported: '데이터가 성공적으로 내보내졌습니다',
    dangerZone: '위험 구역',
    deleteAccountDescription: '계정 삭제는 되돌릴 수 없습니다. 모든 데이터가 영구적으로 삭제됩니다.',
    deleteAccount: '계정 삭제',
    deleteAccountConfirm: '삭제',
    confirmDeleteAccount: '계정을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    // Plan section
    planSection: '내 구독',
    planSectionDescription: '현재 플랜, 한계 및 업그레이드 옵션 보기',
    renewDate: '갱신일: ',
    viewPlanDetails: '플랜 세부 정보 보기',
    eventsLimit: '생성된 이벤트(고유 이벤트 제외)',
    subscriptionStatus: '상태',
    statusActive: '활성',
    statusInactive: '비활성',
    statusScheduledEnd: '예정된 종료',
    subscriptionExpires: '만료일',
    subscriptionRenewsOn: '갱신일',
    cancellationConfirmed: '취소 확인됨!',
    continueAccessUntil: '{{date}}까지 프리미엄 플랜을 계속 이용할 수 있습니다',
    autoDowngradeToFree: '이 날짜 이후 자동으로 무료 플랜으로 전환됩니다.',
    accessUntilEndOfPeriod: '현재 청구 기간 종료까지 액세스를 유지합니다.',
    planFeatures: '플랜 기능',
    featureEvents: '월 이벤트',
    featureSongsPerEvent: '이벤트당 노래',
    unlimited: '무제한',
    upgradePlan: '플랜 업그레이드',
    managePlan: '구독 관리',
  },
  // Email change
  email: {
    changeEmail: '이메일 주소 변경',
    changeEmailDescription: '이메일 주소를 변경하려면 먼저 새 주소를 확인해야 합니다. 확인 이메일이 새 주소로 전송됩니다.',
    currentEmail: '현재 이메일',
    newEmail: '새 이메일 주소',
    newEmailAddress: '새 주소',
    requestEmailChange: '이메일 변경 요청',
    emailRequired: '이메일 주소는 필수입니다',
    emailUnchanged: '새 이메일 주소는 현재 주소와 달라야 합니다',
    emailChangeConfirmationSent: '확인 이메일이 새 이메일 주소로 전송되었습니다.',
    emailChangeInfo: '새 주소가 확인될 때까지 이전 이메일이 활성 상태로 유지됩니다.',
    verifying: '확인 중',
    verifyingDescription: '이메일 주소 확인 중...',
    success: '이메일 확인됨',
    confirmationSuccess: '이메일 주소가 성공적으로 변경되었습니다!',
    confirmationFailed: '확인 실패',
    linkExpired: '링크 만료됨',
    tokenExpired: '확인 링크가 만료되었습니다. 새 링크를 요청하세요.',
    linkExpiredDescription: '확인 링크가 만료되었습니다(24시간 동안 유효). 새 확인 링크를 요청하세요.',
    redirecting: '리디렉션 중...',
    redirectingToLogin: '3초 후 로그인으로 리디렉션...',
    goToSettings: '설정으로 이동',
    backToSettings: '설정으로 돌아가기',
    requestNewLink: '새 링크 요청',
    missingToken: '확인 토큰이 없습니다.',
    validationPending: '확인 대기 중',
    pendingEmailAddress: '확인 대기 중',
  },
  // RGPD - Data Privacy
  rgpd: {
    pageTitle: '개인 데이터',
    pageSubtitle: '데이터와 계정을 안전하게 관리하세요',
    exportData: '내 데이터 다운로드',
    exportDataDescription: '개인 데이터의 전체 사본을 JSON 형식으로 다운로드하세요. 이 데이터를 다른 곳으로 가져오거나 백업으로 보관할 수 있습니다.',
    exportIncludes: '이 내보내기에는 다음이 포함됩니다',
    exportProfile: '프로필 및 기본 설정',
    exportHistory: '이벤트 기록',
    exportEvents: '생성된 이벤트',
    exportSubscription: '구독 정보',
    downloadData: '다운로드 (JSON)',
    exporting: '다운로드 중...',
    exportFormatJSON: '형식: JSON (GDPR 준수)',
    dataExportedSuccess: '✅ 데이터가 성공적으로 다운로드되었습니다!',
    deleteAccount: '내 계정 삭제',
    deleteAccountDescription: '이 작업은 계정과 모든 관련 데이터를 영구적으로 삭제합니다. 이 작업은 되돌릴 수 없습니다.',
    deleteWarning: '⚠️ 중요한 경고',
    deleteIrreversible: '이 작업은 영구적이며 되돌릴 수 없습니다',
    deleteAllData: '모든 데이터가 삭제됩니다',
    deleteNoRecovery: '복구 가능성이 없습니다',
    deleteRecommendation: '계정을 삭제하기 전에 데이터를 다운로드하는 것을 권장합니다.',
    deleteAccountButton: '내 계정 삭제',
    confirmDeletion: '삭제 확인',
    deleteConfirmMessage: '계정을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    continueDelete: '삭제 계속',
    finalDeleteWarning: '최종 확인 - 되돌릴 수 없음',
    finalDeleteMessage: '이것이 마지막 기회입니다! "영구 삭제"를 클릭하면 계정이 되돌릴 수 없게 삭제됩니다.',
    permanentlyDelete: '영구 삭제',
    gdprCompliance: 'GDPR 준수',
    gdprInfo: 'GDPR 규정에 따라 개인 데이터에 액세스, 수정, 삭제 및 이전할 권리가 있습니다. 이 도구를 사용하여 이러한 권리를 행사할 수 있습니다.',
  },
  // Cookies consent
  cookies: {
    title: '🍪 쿠키를 사용합니다',
    description: '경험을 개선하기 위해 쿠키를 사용합니다. 자세한 내용은 정책을 확인하세요.',
    understood: '알겠습니다',
    learnMore: '자세히 알아보기',
    footerNote: '자세한 내용은 쿠키 정책을 확인하세요.',
  },
  // Cookies policy page
  cookiesPage: {
    title: '쿠키 정책',
    subtitle: 'KaraoNow에서 사용하는 쿠키에 대한 완전한 정보',
    overview: '개요',
    overviewText: 'KaraoNow는 사용자 경험을 향상시키고, 계정을 보호하며, 플랫폼 사용 방식을 이해하기 위해 쿠키를 사용합니다. 이 정책은 쿠키를 사용하는 방법과 이유를 설명합니다.',
    whatAreCookies: '쿠키란 무엇인가요?',
    whatAreCookiesText: '쿠키는 기기에 저장된 작은 텍스트 파일입니다. 웹사이트가 기본 설정 및 로그인 데이터와 같은 방문 정보를 기억할 수 있게 합니다.',
    typesOfCookies: '쿠키 유형',
    sessionCookies: '세션 쿠키',
    sessionCookiesText: '이 쿠키는 브라우저를 닫으면 만료됩니다. 세션을 활성 상태로 유지하고 액세스를 보호하는 데 사용됩니다.',
    persistentCookies: '영구 쿠키',
    persistentCookiesText: '이 쿠키는 정의된 기간 동안 기기에 저장되어 있습니다. 다음 방문 시 당신을 인식할 수 있게 합니다.',
    howWeUseCookies: '쿠키 사용 방법',
    useAuthentication: '인증 및 세션 보안',
    usePreferences: '기본 설정 기억(언어, 테마)',
    useSecurity: '남용 및 공격으로부터 보호',
    usePerformance: '플랫폼 성능 개선',
    yourRights: '귀하의 권리',
    yourRightsText: '쿠키를 제어할 권리가 있습니다. 동의 배너를 통해 필수가 아닌 쿠키를 수락하거나 거부할 수 있습니다.',
    managingCookies: '쿠키 관리',
    managingCookiesText: '브라우저 설정을 통해 쿠키를 관리할 수 있습니다. 특정 쿠키를 비활성화하면 KaraoNow 기능에 영향을 줄 수 있습니다.',
    contact: '문의',
    contactText: '이 정책에 대한 질문이 있으시면 문의 페이지 또는 서비스 약관을 통해 문의하세요.',
    footer: '질문이 있으신가요? 홈으로 돌아가기.',
  },
  // Footer
  footer: {
    legal: '법적 고지',
    privacy: '개인정보 보호정책',
    cookies: '쿠키 정책',
    terms: '이용 약관',
  },
  // Legal mentions page
  legalPage: {
    title: '법적 고지',
    subtitle: 'KaraoNow에 대한 법적 정보',
    editor: {
      title: '사이트 편집자',
      name: 'axialdata',
      address: 'Impasse du pélican, 97233 Schoelcher, Martinique',
      phone: '전화: +596696367741',
      email: '이메일: contact@axialdata.net',
      siret: 'SIRET: 49347625300023',
    },
    publication: {
      title: '발행인',
      director: 'Pierre-Yves Léglise',
    },
    hosting: {
      title: '호스팅',
    },
    dataProtection: {
      title: '데이터 보호',
      description: '개인 데이터 보호에 대해 자세히 알아보려면 개인정보 보호정책을 읽어보세요.',
      link: '개인정보 보호정책 읽기',
    },
  },
  // Privacy policy page
  privacyPage: {
    title: '개인정보 보호정책',
    subtitle: '개인 데이터를 보호하는 방법',
    lastUpdated: '최종 업데이트: 2025년 1월 1일',
    intro: {
      title: '소개',
      description: 'KaraoNow는 귀하의 개인정보 보호를 위해 최선을 다하고 있습니다. 이 정책은 GDPR을 준수하여 개인 데이터를 수집, 사용 및 보호하는 방법을 설명합니다.',
    },
    dataCollection: {
      title: '수집된 데이터',
      organizers: {
        title: '주최자용',
        email: '이메일 주소',
        name: '이름, 성 및 조직',
        organization: '조직 세부 정보',
        payment: '결제 정보(제3자 처리업체를 통해)',
        events: '생성된 이벤트에 대한 정보',
      },
      singers: {
        title: '가수용',
        email: '이메일 주소(선택 사항)',
        pseudo: '사용자 별명',
        name: '이름 및 성(선택 사항)',
        participation: '참여한 이벤트',
        history: '대기열에 추가된 노래 기록',
      },
    },
    purposes: {
      title: '데이터 사용',
      authentication: '인증 및 계정 관리',
      eventManagement: '이벤트 생성 및 관리',
      songManagement: '노래 대기열 관리',
      communication: '계정에 대한 중요한 통신',
      billing: '결제 처리 및 청구',
      support: '고객 지원 및 기술 지원',
      preferences: '사용자 경험 개선',
    },
    legalBasis: {
      title: '처리 법적 근거',
      description: '데이터 처리는 등록 시 동의 및 귀하와 KaraoNow 간의 서비스 계약 이행을 기반으로 합니다.',
    },
    retention: {
      title: '데이터 보관 기간',
      active: '활성 데이터: 계정이 활성 상태인 동안 보관',
      inactive: '비활성 데이터: 마지막 로그인 후 12개월 후 삭제',
      legal: '법적 데이터: 법률에서 요구하는 기간 동안 보관',
    },
    rights: {
      title: 'GDPR 권리',
      description: 'GDPR에 따라 다음과 같은 권리가 있습니다:',
      access: '개인 데이터에 액세스할 권리',
      rectification: '데이터 수정할 권리',
      deletion: '잊혀질 권리(데이터 삭제)',
      portability: '데이터 이전할 권리',
      opposition: '처리에 이의를 제기할 권리',
      limitation: '처리 제한할 권리',
      contact: '이러한 권리를 행사하려면 support@karaonow.com으로 문의하세요',
    },
    security: {
      title: '보안',
      description: '무단 액세스, 수정 또는 공개로부터 데이터를 보호하기 위해 적절한 보안 조치를 사용합니다.',
    },
    cookies: {
      title: '쿠키',
      description: 'KaraoNow는 사용자 경험을 향상시키기 위해 쿠키를 사용합니다. 자세한 내용은 쿠키 정책을 읽어보세요.',
      link: '쿠키 정책 읽기',
    },
    contact: {
      title: '문의하기',
      description: '이 정책이나 개인 데이터에 대한 질문이 있으시면 문의하세요:',
      email: 'support@karaonow.com',
    },
  },
  // Terms of Service page
  termsPage: {
    title: '이용 약관',
    subtitle: 'KaraoNow 이용 약관',
    lastUpdated: '최종 업데이트: 2025년 1월 1일',
    intro: {
      title: '소개',
      description: 'KaraoNow에 오신 것을 환영합니다! 플랫폼을 사용함으로써 이 약관에 동의하게 됩니다. 주의 깊게 읽어주세요.',
    },
    service: {
      title: '서비스 설명',
      description: 'KaraoNow는 노래방 이벤트를 관리하기 위한 SaaS 플랫폼입니다. 플랫폼은 두 가지 주요 인터페이스를 제공합니다:',
      organizers: {
        title: '주최자용',
        description: '주최자는 이벤트를 만들고, 가수들과 공유할 QR 코드를 생성하고, 노래 대기열을 관리하며, 가수 순서를 수정할 수 있습니다. 구독 시스템은 세 가지 플랜을 제공합니다: 무료(제한적), 단일 이벤트, 프리미엄(월간 구독).',
      },
      singers: {
        title: '가수용',
        description: '가수는 QR 코드를 통해 이벤트에 참여하고, 이벤트 대기열에 노래를 추가하며, 노래 순서를 볼 수 있습니다. 가수는 계정 없이(게스트 모드) 또는 계정으로 고급 기능을 사용하여 참여할 수 있습니다.',
      },
    },
    accounts: {
      title: '사용자 계정',
      description: 'KaraoNow를 사용하려면 계정을 만들어야 합니다. 자격 증명의 기밀성을 유지할 책임이 있습니다.',
      responsibility: '계정을 통해 수행된 모든 활동에 대한 책임이 있습니다',
      accuracy: '정확하고 최신 정보를 제공하는 데 동의합니다',
      security: '비밀번호의 보안을 유지하는 데 동의합니다',
      notTransferable: '계정은 개인적이며 양도할 수 없습니다',
    },
    subscription: {
      title: '구독 플랜',
      description: 'KaraoNow는 주최자를 위한 여러 구독 플랜을 제공합니다:',
      free: '무료 플랜: 최대 4개 이벤트(모든 상태 결합, 고유 이벤트 제외), 이벤트당 15곡',
      oneShot: '고유 이벤트: 특정 이벤트에 대한 일회성 결제, 무제한 노래, 제한된 유효 기간',
      premium: '월간 구독이 포함된 유료 플랜: 월간 이벤트 할당량이 있는 여러 플랜, 이벤트당 무제한 노래, 자동 월간 갱신',
    },
    payment: {
      title: '결제 조건',
      description: '결제는 안전한 제3자 결제 처리업체를 통해 처리됩니다.',
      currency: '결제는 유로(EUR)로 이루어집니다',
      noRefund: '이미 제공된 서비스에 대해서는 환불이 제공되지 않습니다',
      cancellation: '구독은 언제든지 취소할 수 있습니다',
      automaticRenewal: '월간 구독은 취소하지 않는 한 매월 자동으로 갱신됩니다',
    },
    conduct: {
      title: '사용자 행동',
      description: 'KaraoNow를 합법적이고 윤리적인 방식으로 사용하는 데 동의합니다.',
      prohibited: {
        title: '금지된 행동',
        illegal: '불법 활동 또는 적용 가능한 법률 위반',
        harmful: '유해하거나 공격적이거나 명예훼손적인 콘텐츠',
        harassing: '괴롭힘, 협박 또는 차별',
        spam: '스팸 또는 기타 원치 않는 통신 전송',
        fraud: '사기 또는 사기 시도',
      },
    },
    organizerResponsibilities: {
      title: '주최자 책임',
      description: '주최자는 다음 책임을 수락합니다:',
      songSelection: '노래 콘텐츠의 합법성에 대한 책임이 있습니다',
      eventManagement: '이 약관에 따라 이벤트를 관리해야 합니다',
      dataManagement: '가수 데이터 관리에 대한 책임이 있습니다',
      copyrightCompliance: '노래에 대한 저작권법을 준수하는 데 동의합니다',
    },
    singerRights: {
      title: '가수 권리 및 책임',
      description: '가수는 다음 권리를 가지며 다음 책임을 수락합니다:',
      participation: '다른 사람이 주최한 이벤트에 참여할 수 있습니다',
      songSelection: '이벤트 대기열에 노래를 추가할 수 있습니다',
      noDuplication: '같은 노래를 여러 번 추가할 수 없습니다',
      respect: '주최자가 설정한 규칙을 존중하는 데 동의합니다',
    },
    intellectualProperty: {
      title: '지적 재산권',
      description: 'KaraoNow 및 그 콘텐츠(음악 노래 제외)에 대한 모든 지적 재산권은 KaraoNow에 속합니다. 허가 없이 콘텐츠를 복제하거나 사용할 수 없습니다.',
    },
    liability: {
      title: '책임 제한',
      description: 'KaraoNow는 "있는 그대로" 제공됩니다. 플랫폼 사용으로 인한 직접적이거나 간접적인 손해에 대해 책임을 지지 않습니다. 책임은 지난 달에 구독에 대해 지불한 최대 금액으로 제한됩니다.',
    },
    termination: {
      title: '종료',
      description: 'KaraoNow는 이 약관 위반 시 계정을 일시 중지하거나 종료할 권리를 보유합니다. 언제든지 계정을 종료할 수 있습니다.',
    },
    modifications: {
      title: '약관 수정',
      description: 'KaraoNow는 언제든지 이 약관을 수정할 권리를 보유합니다. 수정 사항은 통지 후 30일 후에 효력을 발생합니다. 이 기간 이후 플랫폼을 계속 사용하는 것은 새로운 약관에 대한 동의를 의미합니다.',
    },
    jurisdiction: {
      title: '관할권',
      description: '이 약관은 프랑스 법률에 의해 규율됩니다. 모든 분쟁은 프랑스의 관할 법원에 제출됩니다.',
    },
    contact: {
      title: '문의',
      description: '이 약관에 대한 질문이 있으시면 문의하세요:',
      email: 'support@karaonow.com',
    },
  },
}
